// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

export const plansTranslationsEn = {
  'plans.modal.title': 'Upgrade Plan',
  'plans.modal.comparison_title': 'Plan Comparison',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': '30,000 characters per month per account.',
  'plans.modal.free.line2': 'Up to 2 contacts per user.',
  'plans.modal.free.line3': 'Up to 2 active conversations per account.',
  'plans.modal.free.line4': 'No file attachments or storage space.',
  'plans.modal.free.line5': 'No data export.',
  'plans.modal.free.line6': 'Message history up to 30 days.',
  'plans.modal.free.line7': '1 device per user only.',
  'plans.modal.premium.line1': '300,000 characters per month per account.',
  'plans.modal.premium.line2': 'Up to 100 contacts per user.',
  'plans.modal.premium.line3': 'Unlimited conversations and chats (tenant).',
  'plans.modal.premium.line4': 'Up to 50 MB storage (tenant).',
  'plans.modal.premium.line5': 'Up to 3 devices per user.',
  'plans.modal.premium.line6': 'Unlimited invitations (tenant).',
  'plans.modal.premium.line7': 'Includes export, automatic translation, and files within plan limits.',
  'plans.modal.premium_block_heading': 'Engine usage limits (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Founder Program',
  'plans.modal.foundation.categories_title': 'Founder categories ({slots} seats)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Position 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'The first to support the project. Highest historical priority.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Position 26–75',
  'plans.modal.foundation.cat_early_desc': 'Early support with special recognition.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Position 76–150',
  'plans.modal.foundation.cat_std_desc': 'Founder seat within the 150 places.',
  'plans.modal.foundation.advantages_title': 'Founder advantages',
  'plans.modal.foundation.adv1': 'Access to the limited Founder pool ({slots} numbered seats).',
  'plans.modal.foundation.adv2': 'Recognition as an ArChat founder user.',
  'plans.modal.foundation.adv3': 'Founder badge and presence in the product ecosystem.',
  'plans.modal.foundation.adv4': 'Historical priority and status by your position (1–150).',
  'plans.modal.foundation.adv5': 'Ongoing benefit tied to your Founder access while the current policy applies.',
  'plans.modal.pro.tagline': 'Standard premium — no Founder component',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Free Plan',
  'plans.free.price': '$0 / month',
  'plans.free.features.contacts': 'Up to 2 contacts per user',
  'plans.free.features.conversations': 'Up to 2 active conversations per account',
  'plans.free.features.no_export': '30,000 characters/month per account; 34 messages/day and 1,000/month; no export',
  'plans.free.features.no_advanced': 'No files or storage; 30-day history; 1 device per user',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Founder Plan',
  'plans.foundation.price': '$15 / month',
  'plans.foundation.features.contacts': 'Same premium contract as PRO (up to 100 contacts per user)',
  'plans.foundation.features.conversations': 'Unlimited conversations and chats (tenant); same limits as PRO',
  'plans.foundation.features.badge': 'Founder program (150 numbered seats)',
  'plans.foundation.features.support': 'USD 15/month while Founder seats are available',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Pro Plan',
  'plans.pro.price': '$19 / month',
  'plans.pro.features.contacts': 'Up to 100 contacts per user',
  'plans.pro.features.conversations': 'Unlimited conversations and chats (tenant); 1,667 msg/day, 50k/month',
  'plans.pro.features.export': 'Up to 50 MB (tenant); export, automatic translation, and files per plan',
  'plans.pro.features.notifications': 'Up to 3 devices per user; unlimited invitations (tenant)',
  'plans.actions.free': 'Current plan',
  'plans.actions.foundation': 'Become a Founder',
  'plans.actions.pro': 'Upgrade to PRO',
  'plans.badges.recommended': 'RECOMMENDED',
  'plans.badges.limited': 'LIMITED',
  'plans.badges.foundation': 'Founder',
  'plans.compare.title': 'Choose your plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.free.price': '$0 / month',
  'plans.compare.foundation.price': '$15 / month',
  'plans.compare.pro.price': '$19 / month',
  'plans.compare.foundation.badge': '150 limited slots',
  'plans.compare.cta.foundation': 'Become a Founder',
  'plans.foundation.coming_soon.title': 'Coming soon',
  'plans.foundation.coming_soon.message': 'This option will be available soon on ArChat. We are working to enable it in all countries and payment platforms.',
  'plans.foundation.coming_soon.confirm': 'OK',
  'plans.payments_disabled.title': 'Subscriptions',
  'plans.payments_disabled.message': 'Subscriptions are being enabled gradually. You can view available plans and their benefits.',
  'plans.payments_disabled.confirm': 'OK',
  'plans.compare.cta.pro': 'Upgrade to PRO',
  'plans.compare.active': 'Current plan',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Message limit reached',
  'plans.limit.message.messages': 'You reached your message limit. Upgrade to FOUNDATION or PRO.',
  'plans.limit.title.storage': 'Storage limit reached',
  'plans.limit.message.storage': 'You reached your storage limit. Upgrade to upload more files.',
  'plans.limit.title.invitations': 'Invitation limit reached',
  'plans.limit.message.invitations': 'You reached your invitation limit. Upgrade to invite more.',
  'plans.founder.remaining': '{count} Founder seats remaining',
  'plans.founder.remaining_last': 'Last {count} Founder seats',
  'plans.founder.remaining_limited': 'Limited: {count} seats left',
  'plans.founder.remaining_very_low': 'Only {count} Founder seats left',
  'plans.founder.soldout': 'Founder sold out',
  'plans.limit.reached': 'Limit reached — Upgrade plan',
  'plans.compare.pro.adjustment_notice': 'Price may be adjusted based on service conditions.',
  'plans.compare.institucional.price': 'Custom pricing',
  'plans.compare.institucional.title': 'Institutional',
  'plans.compare.yourPlan': 'Your plan',
};
